import React from "react";
import FieldLocation from "../../FieldLocation";
import {signupStep2} from "../../../strings/en-us/text";

/*
  <H3>What do I get in the beta version?</H3>
  <p style={{ padding: 16 }}>
    - Use any plan size for free
    <br />- Full access to the MapPlug software
    <br />- Invite team members and staff
    <br />- Future lifetime discount if you want it
    <br />- Help is available to set up your facilities
  </p>
  trialHead='What do I get in the trial version?',
  trialText='',
freeHead='Why is it free?',
  freeText='Since MapPlug is new, we are inviting people to try it
  out for free for a few months so that we can learn how
  to improve it. We just ask for some honest feedback
  from you!',
  buildingHelpText='Don't worry about suite numbers or address specifics! You will be able to fine tune your location by dragging a marker to its exact location.',
  afterSignupHead='What happens after signing up?',
afterSignupText='After signing up here, you’ll be taken to a map
  of your location and can start setting up your
  buildings and assets. Someone will be on Live
  Chat during work days to help you if you get
  stuck!'
  */

const H3 = ({children}) => <h3 className="colorBlue">{children}</h3>;

const SignupSecondStep = ({fetching, data, onChange}) => (
  <div className="row">
    <div className="col-sm-6">
      <H3>{signupStep2.trialHead}</H3>
      <p style={{padding: 16}}>{signupStep2.trialText}</p>
      <H3>{signupStep2.freeHead}</H3>
      <p style={{padding: 16}}>{signupStep2.freeText}</p>
    </div>
    <div className="col-sm-6">
      <div className="row">
        <div className="col-xs-12">
          <FieldLocation
            autoFocus={true}
            disabled={fetching}
            label={signupStep2.mainBuildingEntryLabel}
            addressName="address"
            geoName="geo"
            geoValue={data.geo}
            value={data.address}
            onChange={onChange}
            helpText={signupStep2.buildingHelpText}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="well">
            <H3>{signupStep2.afterSignupHead}</H3>
            <p style={{padding: 16}}>{signupStep2.afterSignupText}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SignupSecondStep;



// WEBPACK FOOTER //
// ./src/components/Signup/SecondStep/index.jsx